import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SocketService } from '../_services/socket.service';
import { AgenteService } from '../_services/agente.service';
import { QueueService } from '../_services/queue.service';
import { GruposService } from '../_services/grupo.service';
import { PeerService } from '../_services/peer.service';
import { IVRService } from '../_services/ivr.service';
import { TroncalService } from '../_services/troncal.service';
import { NetworkService } from '../_services/network.service';

import { AdminMenuComponent } from './adminmenu/adminMenu.component';
import { ConsolaComponent } from './consola_ext/consola.component';
import { ExtensionComponent } from './consola_ext/extension.component';
import { PeerComponent } from './consola_ext/peer.component';
import { TroncalComponent, TimePipe } from './consola_ext/troncal.component';

import { CallcenterComponent } from './consola_call/callcenter.component';
import { AgenteComponent } from './consola_call/agente.component';
import { AgenteOPComponent } from './consola_call/agopciones.component';
import { QueueComponent } from './consola_call/queue.component';
import { AgenteEdicionComponent } from './agente/agente.component';
import { AgenteDetalleComponent } from './agente/agentedetalles.component';
import { TroncalSetupComponent } from './troncal/troncal.component';
import { UsuarioComponent } from './usuarios/usuarios.component';
import { TipificacionesComponent } from './tipificacion/tipificaciones.component';

import { GrupoComponent } from './grupos/grupo.component';
import { GruposComponent } from './grupos/grupos.component';

import { SistemaComponent } from './sistema/sistema.component'

import {Tipificacion} from './tipificacion/tipificacion.module';
import {FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import {ChartModule } from 'angular2-highcharts';

import {UIModule} from '../_extra/ui/ui.module';
import { PollsModule } from './polls/polls.module';
import { PollsComponent } from './polls/polls.component';
import { PollsService } from '../_services/polls.service';

@NgModule({
    providers: [SocketService, AgenteService, QueueService, GruposService, PeerService, IVRService, TroncalService, NetworkService, PollsService],
    imports: [BrowserModule, FormsModule, ReactiveFormsModule, FileUploadModule, ChartModule, UIModule, Tipificacion, PollsModule],
    declarations: [AdminMenuComponent, ConsolaComponent, ExtensionComponent, PeerComponent, TroncalComponent,
        TimePipe,
        CallcenterComponent,
        AgenteComponent, 
        AgenteOPComponent,
        AgenteEdicionComponent,
        AgenteDetalleComponent,
        QueueComponent,
        GrupoComponent, 
        GruposComponent,
        TroncalSetupComponent,
        UsuarioComponent,
        SistemaComponent,
        TipificacionesComponent, 
        PollsComponent
    ],
    exports: [AdminMenuComponent, ConsolaComponent, ExtensionComponent, PeerComponent, TroncalComponent, TimePipe,
        CallcenterComponent,
        AgenteComponent,
        AgenteOPComponent,
        AgenteEdicionComponent,
        AgenteDetalleComponent,
        QueueComponent,
        GrupoComponent, 
        GruposComponent,
        TroncalSetupComponent,
        UsuarioComponent,
        SistemaComponent,
        TipificacionesComponent,
        PollsComponent
    ]
})
export class AdminModule {}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/admin.module.ts